import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import accountDrawerReducer from './accountDrawer/data/reducer';
import accountDrawerSaga from './accountDrawer/data/sagas';
import billingAddressDrawerReducer from './billingAddressDrawer/data/reducer';
import billingAddressDrawerSaga from './billingAddressDrawer/data/sagas';
import contactDrawerReducer from './contactDrawer/data/reducer';
import contactDrawerSaga from './contactDrawer/data/sagas';
import copyAnalyticsDrawerReducer from './copyAnalyticsDrawer/data/reducer';
import createEditActionDefinitionDrawerReducer from './createEditActionDefinitionDrawer/data/reducer';
import createNestDrawerReducer from './createNestingDrawer/data/reducer';
import facilityDrawerReducer from './facilityDrawer/data/reducer';
import facilityDrawerSaga from './facilityDrawer/data/sagas';
import featureFlagDrawerReducer from './featureFlagDrawer/data/reducer';
import managedIntegrationCreateEditDrawerReducer from './managedIntegrationCreateEditDrawer/data/reducer';
import managedIntegrationDrawerReducer from './managedIntegrationDrawer/data/reducer';
import nestingDefaultsDrawerReducer from './nestingDefaultsDrawer/data/reducer';

export const reducer = combineReducers({
  accountDrawer: accountDrawerReducer,
  billingAddressDrawer: billingAddressDrawerReducer,
  contactDrawer: contactDrawerReducer,
  copyAnalyticsDrawer: copyAnalyticsDrawerReducer,
  createEditActionDefinitionDrawer: createEditActionDefinitionDrawerReducer,
  createNestDrawer: createNestDrawerReducer,
  facilityDrawer: facilityDrawerReducer,
  featureFlagDrawer: featureFlagDrawerReducer,
  managedIntegrationCreateEditDrawer: managedIntegrationCreateEditDrawerReducer,
  managedIntegrationDrawer: managedIntegrationDrawerReducer,
  nestingDefaultsDrawer: nestingDefaultsDrawerReducer,
});

export const saga = function* () {
  yield all([
    accountDrawerSaga(),
    billingAddressDrawerSaga(),
    contactDrawerSaga(),
    facilityDrawerSaga(),
  ]);
};
